<template>
  <div class="is-block" :class="{'is-stories':$isEngCom}">
    <div class="categories-wrapper is-flex">
      <div v-if="!edit" class="categories is-flex">
      <a v-for="category in projectCategories" :key="category.name" tabindex="0" @keypress.enter.space="clickCategory(category)" @click="clickCategory(category)" class="a-category gtm-category-tag">
        <span class="tag is-flex gtm-category-tag">
          {{category.parentID === 0 ? projectCategoriesNames(category.id).toUpperCase() : projectCategoriesNames(category.id)}}
        </span>
      </a>
      </div>
      <category-selector v-if="edit && showCategorySelect" class="edit-categories" :fairID="this.fairID" :isRoleAdmin="isRoleAdmin" :project="project" :showAllCategories="showAllCategories" v-model="chosenCategories" :includeSubCategories="true"></category-selector>
      <category-selector-modal v-if="edit && $isYSC" class="edit-categories" :fairID="this.fairID" :project="project" :showAllCategories="showAllCategories" v-model="chosenCategories" :includeSubCategories="true"></category-selector-modal>
    </div>
  </div>
</template>

<script>

import CategorySelector from '@/components/Inputs/CategorySelector'
import CategorySelectorModal from '@/components/Inputs/CategorySelectorModal'

export default {

  props: ['project', 'edit', 'fairID', 'isRoleAdmin'],

  components: {
    CategorySelector,
    CategorySelectorModal
  },
  data: function () {
    return {
      chosenCategories: [],
      projectType: ''
    }
  },
  watch: {
    chosenCategories: function () {
      this.$emit('updateChosenCategories', this.chosenCategories)
    }
  },
  mounted: function () {
    if (!this.project) {
      return
    }
    if (this.$isOhioScience && this.project) {
      this.$store.dispatch('getFairForTemplate', this.project.sourceProjectID).then(fair => {
        this.$store.dispatch('setPage', fair.explore_path)
        this.$store.dispatch('getCategories')
      })
    }
    const categories = this.project.categories || []
    this.chosenCategories = categories.slice()
  },
  computed: {
    projectCategories: function () {
      if (this.$store.getters.categoriesLoaded && this.project && this.project.categories && this.project.categories.length > 0) {
        const parents = {}
        const categories = []
        this.project.categories.forEach((category) => {
          if (category.parentID !== 0 && !parents[category.parentID]) {
            const parent = this.$store.getters.categoryByID(category.parentID)
            if (parent) {
              categories.push(parent)
              parents[category.parentID] = true
            }
          }
          categories.push(category)
        })
        return categories
      }
      return []
    },
    showAllCategories: function () {
      return this.project.isTemplate
    },
    showCategorySelect: function () {
      return !(this.$isYSC || this.$isOhioScience)
    }
  },
  methods: {
    clickCategory: function (category) {
      if (this.$isBroadcomMasters) {
        return
      }
      if (category.subCategories) {
        this.$router.push({ name: 'projectsCategory', params: { category: category.slug } })
      } else {
        this.$router.push({ name: 'viewAll', query: { category: category.slug } })
      }
    },
    projectCategoriesNames: function (id) {
      return this.$store.getters.nameCategoryByID(id)
    }
  }
}

</script>

<style lang="scss" scoped>
  @import '~styles/utils.scss';

  /* Tags */
  .categories-wrapper {
    justify-content: flex-start;
    flex-wrap: wrap;
    align-items: center;
    .categories {
      align-items: center;
      flex-wrap: wrap;
    }

    .a-category {
      display: inline-block;
      height: inherit;
    }
    .tag {
      margin: 0.15rem 0.3rem 0.15rem 0;
      font-size: 0.6rem;
      margin-bottom: 0.3rem;
      color: $grey-dark;
      background-color: $white;
      border-radius: 2px;
      border: 1px solid $grey-light;
    }
  }

  .edit-categories {
    width: 100%;
  }

  .is-stories {
    .tag {
      background-color: $white;
      color: $dark;
      border: 1px solid $grey;
      border-radius: 3px;
      font-size: 0.75rem;
  }
}
</style>
